module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "height": "12rem",
      "overflow": "auto"
    }
  }, _vm._l((_vm.packingFeeDetail.value.packingFeeDetail), function(item) {
    return (item.packing_fee != '0') ? _c('div', {
      staticClass: "fs-28 flex-row-bc item"
    }, [_c('div', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "fs-24"
    }, [_c('span', {
      staticClass: "c-gray",
      staticStyle: {
        "padding-right": ".24rem"
      }
    }, [_vm._v(_vm._s(item.subTitle))]), _vm._v("\n        " + _vm._s(item.value) + "\n      ")])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": ".4rem",
      "left": ".32rem",
      "right": ".32rem",
      "line-height": ".46rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.packingFeeDetail.value.description)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-d64eca4a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/packingFee.vue
// module id = 459
// module chunks = 7